import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import {
  AuctionService,
  BatchPostingService,
  LaunchDarklyService,
  ReservationRequestDto,
  ReservationResponseDto,
  ReservationsService
} from 'remarketing-angular-library';
import { Store } from '@ngxs/store';
import { TranslocoDirective, TranslocoService } from '@jsverse/transloco';
import { take, takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { ChangeStatusModalDirective } from '../change-status-modal.directive';
import { ErrorIconComponent, SpinnerComponent } from 'remarketing-ui-components-lib';



@Component({
    selector: 'app-make-unreserve-modal',
    templateUrl: './make-unreserve-modal.component.html',
    styleUrls: ['./make-unreserve-modal.component.scss'],
    imports: [SpinnerComponent, ErrorIconComponent, TranslocoDirective]
})
export class MakeUnreserveModalComponent extends ChangeStatusModalDirective implements OnInit {
  @Input() numberOfVehicles = 1;
  @Output() close = new EventEmitter();
  _destroyed$ = new Subject();

  textHeader: string;
  textSubHeader: string;
  textDealership: string;
  selectedDealership;
  buyerOeUuid: string;
  isLoading: boolean;
  isError: boolean;
  isIsvFileProcessing = true;
  textError: string;

  constructor(
    store: Store,
    readonly translocoService: TranslocoService,
    auctionService: AuctionService,
    private reservationService: ReservationsService,
    private readonly batchPostingService: BatchPostingService,
    readonly launchDarklyService: LaunchDarklyService
  ) {
    super(store, auctionService, launchDarklyService, translocoService);
  }

  get isIsvReservationHaltEnabled(): boolean {
    return this.launchDarklyService.getFeatureFlag('sell-reservationHaltEnabled', false);
  }

  get isIsvFileUploadHaltEnabled(): boolean {
    return this.launchDarklyService.getFeatureFlag('sell-fileProcessingReservationHaltEnabled', false);
  }

  ngOnInit(): void {
    this.getTranslations();
    if (this.isIsvReservationHaltEnabled) {
      this.isIsvFileProcessing = true;
    } else if (this.isIsvFileUploadHaltEnabled) {
      this.batchPostingService.checkReservationsEnabled().pipe(take(1)).subscribe({
        next: value => {
          this.isIsvFileProcessing = !value.reservationEnabled;
        },
        error: error => {
          console.log(error)
        }
      });
    } else {
      this.isIsvFileProcessing = false;
    }
  }

  makeUnreserve() {
    this.isLoading = true;
    if (this.isIsvReservationHaltEnabled) {
      this.setReservationErrors();
    } else if (this.isIsvFileUploadHaltEnabled) {
      this.batchPostingService
        .checkReservationsEnabled()
        .pipe(take(1))
        .subscribe({
          next: value => {
            if (value.reservationEnabled) {
              this.performUnreserve();
            } else {
              this.setReservationErrors();
            }
          }
        });
    } else {
      this.performUnreserve();
    }
  }

  private performUnreserve() {
    const auctionItemUuids = [];
    this.selectedVehicles.forEach(vehicle => {
      // only adding RESERVED vehicles to the request
      if (vehicle.auctionItemStatus === 'RESERVED') {
        auctionItemUuids.push(vehicle.auctionItemUuid);
        this.buyerOeUuid = vehicle.reservation.reservedForUuid;
      }
    });

    const payload = {
      auctionItemUuids: auctionItemUuids,
      buyerOeUuid: this.buyerOeUuid,
      reservationStatus: 'UNRESERVE'
    } as ReservationRequestDto;
    this.reservationService
      .postVehicleReservations(payload)
      .pipe(take(1))
      .subscribe((response: ReservationResponseDto[]) => {
        this.changeReserveStatus('ACTIVE', response);
        this.isLoading = false;
      });
  }

  setReservationErrors() {
    this.isLoading = false;
    this.isError = true;
    this.textError = 'Reservation changes are disabled while inventory is being uploaded.';
  }

  closeModal() {
    this.isLoading = false;
    this.isError = false;
    this.close.emit();
  }

  getTranslations() {
    super.getTranslations();
    const keyParams = {
      'sellModule.manageInventory.actionListModal.makeUnreserveModal.textHeader': {
        numberOfVehicles: this.numberOfVehicles
      },
      'sellModule.manageInventory.actionListModal.makeUnreserveModal.textSubHeader': {}
    };

    this.translocoService
      .selectTranslateObject(keyParams)
      .pipe(takeUntil(this._destroyed$))
      .subscribe(translate => {
        this.textHeader = translate[0];
        this.textSubHeader = translate[1];
      });
  }
}
